import React from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { Menu, MenuItem } from "@blueprintjs/core";

import { useBasePath } from "@hooks";

import { EDITOR_EXAMPLES } from "@assets/EditorExamples";

const Example = styled(MenuItem)`
  margin-bottom: 8px;
`;

const ExampleTitle = styled.div`
  display: block;
  color: inherit;
  text-decoration: none;
  font-weight: var(--global-font-weight-bold);
  :hover {
    color: inherit;
  }
`;

export const SplashExamples: React.FC<{ style?: React.CSSProperties }> = ({
  style,
}) => {
  const displayedExamples = EDITOR_EXAMPLES.slice(0, 3);
  const basePath = useBasePath();
  const history = useHistory();

  return (
    <Menu style={{ maxWidth: "fit-content", ...style }}>
      {displayedExamples.map((e, idx) => (
        <Example
          text={
            <div key={idx}>
              <ExampleTitle>{e.title}</ExampleTitle>
              {e.description}
            </div>
          }
          onClick={() => history.push(`${basePath}/editor/s/${e.snippet_id}`)}
        />
      ))}
    </Menu>
  );
};
